import React from 'react';

interface StatusStampProps {
  status: 'valid' | 'expired';
}

const StatusStamp = ({ status }: StatusStampProps) => {
  const isValid = status === 'valid';
  const color = isValid ? 'green' : 'red';

  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 110,
        height: 110,
        flexShrink: 0,
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          borderRadius: '50%',
          border: `4px solid ${color}`,
          opacity: 0.85,
        }}
      />
      <div
        style={{
          position: 'absolute',
          inset: 8,
          borderRadius: '50%',
          border: `2px solid ${color}`,
          opacity: 0.55,
        }}
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          transform: isValid ? 'rotate(-15deg)' : 'rotate(-18deg)',
          gap: 2,
        }}
      >
        <span
          style={{
            fontSize: 9,
            fontWeight: 700,
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            color,
          }}
        >
          {isValid ? '— VERIFIED —' : '— STATUS —'}
        </span>
        <span
          style={{
            fontSize: isValid ? 20 : 17,
            fontWeight: 800,
            letterSpacing: '0.05em',
            textTransform: 'uppercase',
            color,
            lineHeight: 1,
          }}
        >
          {isValid ? 'VALID' : 'EXPIRED'}
        </span>
        <span
          style={{
            fontSize: 9,
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            color,
            opacity: 0.8,
          }}
        >
          DOCUMENT
        </span>
      </div>
    </div>
  );
};

export default StatusStamp;
